import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ellipsis-cell" }
const _hoisted_2 = { class: "ellipsed" }
const _hoisted_3 = { nowrap: "" }
const _hoisted_4 = {
  nowrap: "",
  class: "limit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_TableHead = _resolveComponent("TableHead")
  const _component_Highlight = _resolveComponent("Highlight")
  const _component_Column = _resolveComponent("Column")
  const _component_Icon = _resolveComponent("Icon")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_FLimitModal = _resolveComponent("FLimitModal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$options.c_users)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode(" Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          class: "data-table",
          items: $options.c_users,
          lazy: false,
          "sort-field": _ctx.sort_field,
          "sort-order": _ctx.sort_order,
          onSort: $options.onSort
        }, {
          "header-right": _withCtx(() => [
            _createVNode(_component_SearchInput, { onSearch: $options.onSearch }, null, 8 /* PROPS */, ["onSearch"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              sortable: "",
              "sort-field": "name",
              style: {"width":"70%"}
            }, {
              sorticon: _withCtx(({sortOrder}) => [
                _createVNode(_component_TableHead, {
                  name: "Name",
                  sortable: "",
                  "sort-order": sortOrder
                }, null, 8 /* PROPS */, ["sort-order"])
              ]),
              body: _withCtx(({data: {name}}) => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_Highlight, {
                      text: name,
                      highlight: _ctx.highlight
                    }, null, 8 /* PROPS */, ["text", "highlight"])
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Column, {
              sortable: "",
              "sort-field": "email"
            }, {
              sorticon: _withCtx(({sortOrder}) => [
                _createVNode(_component_TableHead, {
                  name: "E-mail",
                  sortable: "",
                  "sort-order": sortOrder
                }, null, 8 /* PROPS */, ["sort-order"])
              ]),
              body: _withCtx(({data: {email}}) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_Highlight, {
                    text: email,
                    highlight: _ctx.highlight
                  }, null, 8 /* PROPS */, ["text", "highlight"])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Column, {
              "sort-field": "storage_limit",
              sortable: ""
            }, {
              sorticon: _withCtx(({sortOrder}) => [
                _createVNode(_component_TableHead, {
                  name: "Flimit",
                  sortable: "",
                  "sort-order": sortOrder
                }, null, 8 /* PROPS */, ["sort-order"])
              ]),
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$utils.format.bytes(data.storage_limit)) + " ", 1 /* TEXT */),
                  _createVNode(_component_Icon, {
                    class: "pointer",
                    icon: "edit-03",
                    width: "2rem",
                    height: "2rem",
                    onClick: () => $options.openFLimit(data)
                  }, null, 8 /* PROPS */, ["onClick"])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Column, {
              sortable: "",
              "sort-field": "occupied_storage"
            }, {
              sorticon: _withCtx(({sortOrder}) => [
                _createVNode(_component_TableHead, {
                  name: "FUsed",
                  sortable: "",
                  "sort-order": sortOrder
                }, null, 8 /* PROPS */, ["sort-order"])
              ]),
              body: _withCtx(({data: {occupied_storage}}) => [
                _createTextVNode(_toDisplayString(_ctx.$utils.format.bytes(occupied_storage)), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["items", "sort-field", "sort-order", "onSort"])),
    _createVNode(_component_FLimitModal, {
      ref: "flimitModal",
      onUpdate: $options.onUserUpdate
    }, null, 8 /* PROPS */, ["onUpdate"])
  ], 64 /* STABLE_FRAGMENT */))
}